import React, { Component } from 'react'

import { Treemap, Pie } from "d3plus-react"; //https://www.npmjs.com/package/d3plus-react
import WidgetLoader from "./WidgetLoader"; //https://www.npmjs.com/package/react-bootstrap-typeahead
import { Row, Col, ButtonToolbar, Button, Checkbox } from "react-bootstrap";
import Datetime from "react-datetime";
import OgaTable from "../OgaTables/OgaTable";
import Loader from "../elements/loader/Loader";
import HttpClient from "../../utils/HttpClient/HttpClient";
import MaterialIcon from "material-icons-react";
import TopWidgetComponent from "./TopWidgetComponent";
import OgaSelect from "../elements/OgaSelect";
import AffiliateTypeahead from "../Typeaheads/AffiliateTypeahead";
//https://github.com/pushtell/react-bootstrap-date-picker#readme


export default class Widget5 extends Component {

    httpClient;
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            loading: false,
            loaded: false,
            values: null,
            affiliate: null
        };
        this.httpClient = new HttpClient(true);
    }

    componentWillMount() {
        this.setState({ loaded: true, values: this.values });
    }

    onPageChange = (pageNumber) => {
        this.setState({ loading: true });

        setTimeout(() => {
            this.setState({
                loading: false
            })
        }, 2000)
    }

    onAffiliateChange(affiliate) {
        if (!affiliate) return;

        this.setState({ loading: true, affiliate: affiliate });
        this.httpClient.get(`oga/widgets/payment-detail?customerId=${affiliate.id}`).then(res => {
            this.setState({ loading: false, values: res.data });
        }).catch((error) => {
            console.log("enter here error login request");
            this.setState({ loading: false });
        })
    }

    PDFReport() {
        this.requestReport('pdf');
    }

    XLSReport() {
        this.requestReport('xls');
    }

    requestReport(ext) {
        let queryParam = `?customerId=${this.state.affiliate.id}` + (ext === 'xls' ? '&excel=true' : '');
        this.httpClient.get("oga/report/payment-detail" + queryParam, { responseType: 'blob' })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.' + ext);
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                console.error("oga/report/payment-detail Error", err);
            })
    }

    render() {
        let loaded = this.state.loaded;
        return (
            <div className="widget-container w-100">
                {
                    !loaded ?
                        <div className={"w-100 centered"} style={{ minHeight: "400px" }}>
                            <Loader show={true} />
                        </div> :
                        <div>
                            <Row className="widget-container-padding">
                                <Col md={12} className={"no-padding no-margin bottom-margin-8"}>
                                    <form>
                                        <TopWidgetComponent id={this.props.id}
                                            label={this.props.name}
                                            onSelectionChange={(val, id) => this.props.onSelectionChange(val, id)}
                                            isDashboard={this.props.isDashboard} />

                                        <AffiliateTypeahead
                                            className="bottom-margin-8"
                                            onRef={ref => (this.customerTypeahead = ref)}
                                            selection={this.state.selectedAffiliate}
                                            onAffiliateChange={(affiliate) => this.onAffiliateChange(affiliate)} />
                                    </form>
                                </Col>
                                {this.state.affiliate && <Col md={12} className={"no-padding no-margin bottom-margin-8 top-margin-8"}>
                                    <ButtonToolbar className="float-right">
                                        <Button className="bg-light-secondary"
                                            onClick={() => this.PDFReport()}>PDF</Button>
                                        &nbsp;&nbsp;
                                        <Button className="bg-light-secondary"
                                            onClick={() => this.XLSReport()}>Excel</Button>
                                    </ButtonToolbar>
                                </Col>
                                }
                                <Col md={12} className={"no-padding no-margin"}>
                                    <OgaTable
                                        loading={this.state.loading}
                                        headers={["Cuota", "Lote", "Fecha de pago", "Tiempo para pagar"]}
                                        properties={["quota", "productName", "dueDate", "timeToPay"]}
                                        pullRight={[3]}
                                        emptyMessage="Llene el formulario"
                                        format={[{ range: 3, parse: (v) => v === 1 || v === -1 ? `${v} Día` : `${v} Dias` }]}
                                        onPageChange={this.onPageChange}
                                        values={this.state.values} />
                                </Col>
                            </Row>
                        </div>
                }
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Widgets/Widget5.jsx